"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackMixin = void 0;
class TrackMixin {
    static ApplyMixin(object) {
        object.onChangedAttachment = TrackMixin.prototype.onChangedAttachment.bind(object);
        object.offChangedAttachment = TrackMixin.prototype.offChangedAttachment.bind(object);
        object.offEventListener = TrackMixin.prototype.offEventListener.bind(object);
        object.removeAllAnimationListeners = TrackMixin.prototype.removeAllAnimationListeners.bind(object);
        object.emitAttachmentEvents = TrackMixin.prototype.emitAttachmentEvents.bind(object);
        object.emitAnimationEvents = TrackMixin.prototype.emitAnimationEvents.bind(object);
        object.emitFrameEvents = TrackMixin.prototype.emitFrameEvents.bind(object);
        object.onEnd = TrackMixin.prototype.onEnd.bind(object);
        object.onStart = TrackMixin.prototype.onStart.bind(object);
        object.offEnd = TrackMixin.prototype.offEnd.bind(object);
        object.offStart = TrackMixin.prototype.offStart.bind(object);
        object.onRemovedFromParent = TrackMixin.prototype.onRemovedFromParent.bind(object);
        object.onRemovedAttachment = TrackMixin.prototype.onRemovedAttachment.bind(object);
        object.onAddedAttachment = TrackMixin.prototype.onAddedAttachment.bind(object);
        object.offRemovedAttachment = TrackMixin.prototype.offRemovedAttachment.bind(object);
        object.offAddedAttachment = TrackMixin.prototype.offAddedAttachment.bind(object);
        object.removeChildPassiveTracks = TrackMixin.prototype.removeChildPassiveTracks.bind(object);
        object.addNeededChildPassiveTracks = TrackMixin.prototype.addNeededChildPassiveTracks.bind(object);
    }
    removeChildPassiveTracks(action) {
        if (!this.activePassiveAttachmentTracks)
            return;
        for (let i = 0; i < this.activePassiveAttachmentTracks.length; i++) {
            if (!this.activePassiveAttachmentTracks[i].removePassiveTrack(action)) {
                throw new Error(`expected true`);
            }
        }
        delete this.activePassiveAttachmentTracks;
    }
    addNeededChildPassiveTracks(action, array, playOptions) {
        if (!array)
            return;
        for (let i = 0; i < array.length; i++) {
            if (array[i].addPassiveTrack(action, playOptions)) {
                if (!this.activePassiveAttachmentTracks) {
                    this.activePassiveAttachmentTracks = [array[i]];
                }
                else {
                    this.activePassiveAttachmentTracks.push(array[i]);
                }
            }
        }
    }
    removeAllAnimationListeners() {
        if (this._onFrameEventListeners) {
            Object.keys(this._onFrameEventListeners).forEach(e => {
                this._onFrameEventListeners[e].length = 0;
                delete this._onFrameEventListeners[e];
            });
        }
        delete this._onFrameEventListeners;
        if (this._onEndListeners)
            this._onEndListeners.length = 0;
        delete this._onEndListeners;
        if (this._onStartListeners)
            this._onStartListeners.length = 0;
        delete this._onStartListeners;
        if (this._onAddededListeners)
            this._onAddededListeners.length = 0;
        delete this._onAddededListeners;
        if (this._onRemovedListeners)
            this._onRemovedListeners.length = 0;
        delete this._onAddededListeners;
        if (this._onEndListeners)
            this._onEndListeners.length = 0;
        delete this._onEndListeners;
    }
    onFrameEvent(eventName, cb) {
        if (!(this._onFrameEventListeners)) {
            this._onFrameEventListeners = { [eventName]: [cb] };
        }
        else if (!this._onFrameEventListeners[eventName]) {
            this._onFrameEventListeners[eventName] = [cb];
        }
        else {
            this._onFrameEventListeners[eventName].push(cb);
        }
    }
    offFrameEvent(eventName, cb) {
        if (this._onFrameEventListeners) {
            const array = this._onFrameEventListeners[eventName];
            if (array && (!this.offEventListener(array, cb))) {
                delete this._onFrameEventListeners[eventName];
                if (!(Object.keys(this._onFrameEventListeners)).length) {
                    delete this._onFrameEventListeners;
                }
            }
        }
    }
    emitFrameEvents(frameEventName, action, data, track) {
        if (this._onFrameEventListeners) {
            const array = this._onFrameEventListeners[frameEventName];
            if (array) {
                for (let i = 0; i < array.length; i++) {
                    array[i](action, track, data);
                }
            }
        }
    }
    emitAttachmentEvents(arrayName, attachmentSlotName, attachmentName, track) {
        //  console.log('emitting', this, arrayName);
        if (this[arrayName]) {
            for (let i = 0; i < this[arrayName].length; i++) {
                this[arrayName][i](attachmentSlotName, attachmentName, track);
            }
        }
    }
    emitAnimationEvents(arrayName, actionName, track) {
        if (this[arrayName]) {
            for (let i = 0; i < this[arrayName].length; i++) {
                this[arrayName][i](actionName, track);
            }
        }
    }
    onChangedAttachment(cb) {
        if (!this._onChangeAttachmentListeners) {
            this._onChangeAttachmentListeners = [cb];
        }
        else {
            this._onChangeAttachmentListeners.push(cb);
        }
    }
    offChangedAttachment(cb) { if (!(this.offEventListener(this._onChangeAttachmentListeners, cb)))
        delete this._onChangeAttachmentListeners; }
    onEnd(cb) {
        if (!this._onEndListeners) {
            this._onEndListeners = [cb];
        }
        else {
            this._onEndListeners.push(cb);
        }
    }
    offEnd(cb) { if (!(this.offEventListener(this._onEndListeners, cb)))
        delete this._onEndListeners; }
    onStart(cb) {
        if (!this._onStartListeners) {
            this._onStartListeners = [cb];
        }
        else {
            this._onStartListeners.push(cb);
        }
    }
    offStart(cb) { if (!(this.offEventListener(this._onStartListeners, cb)))
        delete this._onStartListeners; }
    onRemovedFromParent(cb) {
        if (!this._onRemovedFromParentListeners) {
            this._onRemovedFromParentListeners = [cb];
        }
        else {
            this._onRemovedFromParentListeners.push(cb);
        }
    }
    onRemovedAttachment(cb) {
        if (!this._onRemovedListeners) {
            this._onRemovedListeners = [cb];
        }
        else {
            this._onRemovedListeners.push(cb);
        }
    }
    offRemovedAttachment(cb) { if (!(this.offEventListener(this._onRemovedListeners, cb)))
        delete this._onRemovedListeners; }
    onAddedAttachment(cb) {
        if (!this._onAddededListeners) {
            this._onAddededListeners = [cb];
        }
        else {
            this._onAddededListeners.push(cb);
        }
    }
    offAddedAttachment(cb) { if (!(this.offEventListener(this._onAddededListeners, cb)))
        delete this._onAddededListeners; }
    offEventListener(array, cb) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] === cb) {
                array.splice(i, 1);
                return array.length;
            }
        }
        return -1;
    }
}
exports.TrackMixin = TrackMixin;
//# sourceMappingURL=module.js.map